import React from 'react'
import { FaGripfire } from "react-icons/fa"

export default function ServiceCard({
    service
}) {
    return (
        <div className='flex flex-col gap-3 justify-between w-[400px] relative h-[500px] text-center bg-white rounded-2xl border-2 p-10 hover:border-[#E4B456] shadow-sm shadow-gray-300 transition-all duration-200 ease-in-out'>
            {service?.isRecommended && (
                <FaGripfire className='text-[30px] text-[#E4B456] m-auto absolute top-[10px] left-[10px]' />
            )}
            <div className='flex flex-col items-center justify-center gap-3'>
                <div className='flex flex-col items-center justify-center gap-3'>

                    <h3 className="text-2xl font-medium text-gray-800 smsize:text-[20px] smsize:leading-5">
                        {service?.title.indexOf('<br>') !== -1 ? <p dangerouslySetInnerHTML={{ __html: service.title }}></p> : service.title}
                    </h3>
                    <div className='flex flex-col items-center justify-center text-[18px] text-[#E4B456] font-medium'>
                        {service.time_money_str ?
                            <span className='' dangerouslySetInnerHTML={{ __html: service.time_money_str }} ></span> :
                            <>
                                {service.duration > 0 && <span className=''>{service.duration} Minutes</span>}
                                {service.price > 0 && <span className=''>${service.price}</span>}
                            </>
                        }
                    </div>
                </div>
                <p className='text-[15px] leading-5 font-light text-left line-clamp-[8] overflow-y-hidden' dangerouslySetInnerHTML={{ __html: service.description }}></p>
            </div>
            <div className='flex justify-center mt-5'>
                <a
                    href={`https://flirtcosmetics.zenoti.com/webstoreNew/services/223d7d44-e6d0-4c03-9841-e653d25d4d0c?serviceid=${service.pos_service_id}`}
                    target='_blank'
                    rel="noopener noreferrer"
                    className="bg-[#202020] rounded-full cursor-pointer hover:bg-fitzba-bright-gold-static text-white py-2 px-4 w-[200px]">
                    Book Now
                </a>
            </div>
        </div>
    )
}
